module.exports = __webpack_public_path__ + "static/img/dw.155238a2.png";